<script setup>
import Banner from '@/components/Banner.vue';
import BurgerForm from '@/components/BurgerForm.vue';
</script>

<template>
  <Banner />
  <div class="main-container">
    <h1>Monte o seu Burger:</h1>
    <BurgerForm />
  </div>
</template>